import { render } from "./Historical.vue?vue&type=template&id=efd5fe70&scoped=true"
import script from "./Historical.vue?vue&type=script&lang=js"
export * from "./Historical.vue?vue&type=script&lang=js"

import "./Historical.vue?vue&type=style&index=0&id=efd5fe70&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-efd5fe70"

export default script